import React from 'react';

const FlashIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(11.000000, 6.000000)'>
        <polygon points='0 0 0 11 3 11 3 20 10 8 6 8 10 0' />
      </g>
    </g>
  </svg>
);

export default FlashIcon;
